<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '../ui-utils.ts';
import { Primitive, type PrimitiveProps } from 'reka-ui';

const props = withDefaults(
  defineProps<
    PrimitiveProps & {
      showOnHover?: boolean;
      class?: HTMLAttributes['class'];
    }
  >(),
  {
    as: 'button',
  },
);
</script>

<template>
  <Primitive
    data-sidebar="menu-action"
    :class="
      cn(
        'ring-sidebar-ring glass-button absolute top-1.5 right-1 flex aspect-square w-5 items-center justify-center rounded-md p-0 text-white outline-hidden transition-all duration-200 peer-hover/menu-button:text-white hover:bg-white/25 hover:text-white focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0',
        // Increases the hit area of the button on mobile.
        'after:absolute after:-inset-2 md:after:hidden',
        'peer-data-[size=sm]/menu-button:top-1',
        'peer-data-[size=default]/menu-button:top-1.5',
        'peer-data-[size=lg]/menu-button:top-2.5',
        'group-data-[collapsible=icon]:hidden',
        showOnHover &&
          'group-focus-within/menu-item:opacity-100 group-hover/menu-item:opacity-100 peer-data-[active=true]/menu-button:text-white data-[state=open]:opacity-100 md:opacity-0',
        props.class,
      )
    "
    :as="as"
    :asChild="asChild"
  >
    <slot />
  </Primitive>
</template>
